// import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
// import UnsavedChanges from '../Modals/UnsavedChanges';
// import { useNavigate } from 'react-router-dom';

// interface UnsavedChangesContextType {
//   hasUnsavedChanges: boolean;
//   setHasUnsavedChanges: (value: boolean) => void;
// }

// interface UnsavedChangesProviderProps {
//   children: ReactNode;
// }

// const UnsavedChangesContext = createContext<UnsavedChangesContextType | undefined>(undefined);

// export const UnsavedChangesProvider: React.FC<UnsavedChangesProviderProps> = ({ children }) => {
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [nextRoute, setNextRoute] = useState<string | null>(null);

//   useEffect(() => {
//     const handleBeforeUnload = (event: BeforeUnloadEvent) => {
//       if (hasUnsavedChanges) {
//         event.preventDefault();
//         event.returnValue = '';
//       }
//     };

//     const handlePopState = (event: PopStateEvent) => {
//       if (hasUnsavedChanges) {
//         setShowPopup(true);
//         event.preventDefault();
//         window.history.pushState(null, document.title, window.location.href); // Prevent navigation
//       }
//     };

//     window.addEventListener('beforeunload', handleBeforeUnload);
//     window.addEventListener('popstate', handlePopState);

//     return () => {
//       window.removeEventListener('beforeunload', handleBeforeUnload);
//       window.removeEventListener('popstate', handlePopState);
//     };
//   }, [hasUnsavedChanges]);

//   const confirmNavigation = (proceed: boolean) => {

//     if (proceed && nextRoute) {
//       // navigate(nextRoute);
//     }
//     setHasUnsavedChanges(false); // Reset unsaved changes
//     setShowPopup(false);
//     setNextRoute(null);
//   };

//   return (
//     <UnsavedChangesContext.Provider value={{ hasUnsavedChanges, setHasUnsavedChanges }}>
//       {children}
//       {showPopup && (
//         // <UnsavedChanges
//         //   // message="You have unsaved changes. Do you want to leave this page?"
//         //   onConfirm={() => confirmNavigation(true)}
//         //   onCancel={() => confirmNavigation(false)}
//         // />
//         <UnsavedChanges confirmYes={() => confirmNavigation(true)} stayHere={() => confirmNavigation(false)} />
//       )}
//     </UnsavedChangesContext.Provider>
//   );
// };

// export const useUnsavedChanges = () => {
//   const context = useContext(UnsavedChangesContext);
//   if (!context) {
//     throw new Error("useUnsavedChanges must be used within an UnsavedChangesProvider");
//   }
//   return context;
// };

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { useNavigate } from "react-router-dom";
import UnsavedChanges from "../Modals/UnsavedChanges";

interface UnsavedChangesContextType {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (value: boolean) => void;
  isWatched: boolean;
  setIsWatched: (value: boolean) => void;
  paths: string;
  setPaths: (value: string)=> void;
}

interface UnsavedChangesProviderProps {
  children: ReactNode;
}

const UnsavedChangesContext = createContext<
  UnsavedChangesContextType | undefined
>(undefined);

export const UnsavedChangesProvider: React.FC<UnsavedChangesProviderProps> = ({
  children,
}) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [nextRoute, setNextRoute] = useState<string | null>(null);
  const navigate = useNavigate();


  const [isWatched, setIsWatched] = useState(false);
    const [paths, setPaths] = useState("");

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    const handlePopState = (event: PopStateEvent) => {
      if (hasUnsavedChanges) {
        setShowPopup(true);
        setNextRoute(window.location.pathname); // Save the intended navigation
        window.history.pushState(null, document.title, window.location.href); // Prevent immediate navigation
      }
    };

    // Push an initial state to enable interception
    window.history.pushState(null, document.title, window.location.href);

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [hasUnsavedChanges]);

  const confirmNavigation = (proceed: boolean) => {
    if (proceed && nextRoute) {
      setHasUnsavedChanges(false);
      setShowPopup(false);
      navigate(nextRoute); // Navigate after confirmation
    } else {
      setShowPopup(false);
      setNextRoute(null);
      window.history.pushState(null, document.title, window.location.href); // Reset state to stay on the current page
    }
  };

  console.log('iswatched',  isWatched)

  return (
    <UnsavedChangesContext.Provider
      value={{
        hasUnsavedChanges,
        setHasUnsavedChanges,
        isWatched,
        setIsWatched,
        paths,
        setPaths,

      }}
    >
      {children}
      {showPopup && (
        <UnsavedChanges
          confirmYes={() => confirmNavigation(true)}
          stayHere={() => confirmNavigation(false)}
        />
      )}
    </UnsavedChangesContext.Provider>
  );
};

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    throw new Error(
      "useUnsavedChanges must be used within an UnsavedChangesProvider"
    );
  }
  return context;
};
